import type { CardContent as RtgCardContent } from "@revotech-group/revotech-ui-kit";
import { html } from "lit";
import { customElement, property } from "lit/decorators.js";

import { mapStyles, nextPaint } from "@/utils";

import { BaseElement } from "@/components/wrappers/base-element/base-element";

import type {
  ContainerAlignment,
  ContainerProps,
  ContainerType,
} from "./container.types";

@customElement("sb-container")
export class SbContainer extends BaseElement implements ContainerProps {
  @property() id = "";

  @property() type: ContainerType = "flex_column";
  @property({ type: Boolean }) root: boolean = false;
  @property({ type: Boolean }) form: boolean = false;

  @property() alignment?: ContainerAlignment;

  protected createRenderRoot() {
    return this;
  }

  protected async firstUpdated() {
    await this.updateComplete;
    if (!this.root) {
      const outer = this.querySelector(
        `div[part=${this.id ? this.id : "container"}]`,
      ) as HTMLElement;
      console.log("first updated", outer);
      if (outer) {
        this.moveLightDomChildrenInto(outer);
      }
      return;
    }
    const outer = this.querySelector(
      "rtg-card-content",
    ) as RtgCardContent | null;

    if (outer?.updateComplete) {
      await outer.updateComplete; // 🔥 THIS is the missing piece
    }

    const inner = outer?.querySelector(
      'div[data-slot="card-content"]',
    ) as HTMLElement | null;

    if (inner) {
      this.moveLightDomChildrenInto(inner);
    }

    await nextPaint();
  }

  protected async updated() {
    await this.updateComplete;
    await nextPaint();
    // this.updateWidthsIfNeeded();
  }

  private get containerStyles() {
    return {
      display: "flex",
      "flex-direction": this.type === "flex_column" ? "column" : "row",
    };
  }

  render() {
    if (this.root) {
      return html`
        <rtg-card part=${this.id ? this.id : "container"}>
          <rtg-card-content></rtg-card-content>
        </rtg-card>
      `;
    }
    return html`<div
      part=${this.id ? this.id : "container"}
      style=${mapStyles(this.containerStyles)}
    ></div>`;
  }
}
